import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import * as _ from 'lodash';

import { MediaModel } from '../../models/MediaModel';
import { TypeMediaModel } from '../../models/TypeMediaModel';
import { NotificationService } from '../../services/notification.service';
import { CacheService } from '../../services/cache-service';
import { MediaService } from '../../services/media.service';

@Component({
  selector: 'uploads',
  templateUrl: './uploads.component.html',
  styleUrls: ['./uploads.component.css'],
})
export class UploadsComponent implements OnInit {
  @Input() editMode: boolean = true;
  @Input() maxHeight: string = '200px';
  @Input() maxWidth: string = '200px';
  @Input() overwriteTitre?: string = null;

  private _medias: MediaModel[];
  @Input()
  set medias(value: MediaModel[]) {
    this._medias = value;
  }
  get medias(): MediaModel[] {
    return this._medias;
  }

  private _typeMediaId: number;
  @Input()
  set typeMediaId(value: number) {
    this._typeMediaId = value;
    // Load Media
    if (this._typeMediaId) {
      this.cacheService.getTypeMedia(this._typeMediaId).subscribe(typeMedia => {
        this.typeMedia = typeMedia;
        this.texteAjout = this.typeMedia.TexteAjout;
        this.texteOuvrir = this.typeMedia.TexteOuvrir;
        this.texteModification = this.typeMedia.TexteModification;
        this.texteSuppression = this.typeMedia.TexteSuppression;
        this.accept = this.typeMedia.FormatAccepte;
        this.texteAideFormat = this.typeMedia.TexteAideFormat;
        this.texteAvertissement = this.typeMedia.TexteAvertissement;
        this.titreColonne = this.typeMedia.Nom;
      });
    } else {
      this.typeMedia = null;
      this.texteAjout = 'Ajouter un fichier';
      this.texteOuvrir = 'Ouvrir le fichier';
      this.texteModification = 'Mettre à jour le fichier';
      this.texteSuppression = 'Supprimer le fichier';
      this.accept = 'image/png, image/jpeg';
      this.texteAideFormat = null;
      this.texteAvertissement = null;
      this.titreColonne = 'Fichiers';
    }
  }
  get typeMediaId(): number {
    return this._typeMediaId;
  }

  @Input() isImage: boolean = true;

  @Output() mediasChange: EventEmitter<MediaModel[]> = new EventEmitter<MediaModel[]>();

  typeMedia: TypeMediaModel;
  titreColonne: string = 'Fichiers';
  texteAjout: string = 'Ajouter un fichier';
  texteOuvrir: string = 'Ouvrir le fichier';
  texteModification: string = 'Mettre à jour le fichier';
  texteSuppression: string = 'Supprimer le fichier';
  accept: string = 'image/png, image/jpeg';
  texteAideFormat: string = null;
  texteAvertissement: string = null;
  edits: boolean[] = [];

  constructor(
    private notificationService: NotificationService,
    private cacheService: CacheService,
    public mediaService: MediaService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit() {}

  public edit(index: number, event?: any) {
    event?.stopPropagation();
    this.edits[index] = true;
  }

  public endEdit(index: number, event?: any) {
    event?.stopPropagation();
    this.edits[index] = false;
  }

  onKeydown(event) {
    if (event.key !== 'Enter') {
      event.stopPropagation();
    }
  }

  public deleteFile(media: MediaModel) {
    this.confirmationService.confirm({
      message: 'Êtes-vous certain de vouloir supprimer ce fichier ?',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        let i = this._medias.indexOf(media);
        this._medias.splice(i, 1);
        this.mediasChange.emit(this._medias);
      },
    });
  }

  public uploadFile(files, index?: number) {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];

    this.mediaService.uploadMedia(this._typeMediaId, fileToUpload).subscribe(
      media => {
        if (media.Erreur) {
          this.notificationService.error(media.Erreur);
        } else if (media.Media) {
          if (index != null) {
            let oldName = this._medias[index].Nom;
            this._medias[index] = media.Media;
            this._medias[index].Nom = oldName;
          } else {
            // Nouveau
            this._medias.push(media.Media);
          }
          this.mediasChange.emit(this._medias);
        }
      },
      error => {
        this.notificationService.error('Une erreur est survenue lors du téléchargement du fichier.');
      },
    );
  }
}
